import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["stroke"];
const _hoisted_3 = ["stroke"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("path", {
    d: "M4.66536 8L1.33203 9.66667L7.76018 12.8807C7.84764 12.9245 7.89137 12.9463 7.93723 12.9549C7.97786 12.9626 8.01954 12.9626 8.06016 12.9549C8.10603 12.9463 8.14976 12.9245 8.23721 12.8807L14.6654 9.66667L11.332 8",
    stroke: $props.color,
    "stroke-width": "1.18",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-dasharray": "2 2"
  }, null, 8, _hoisted_2), _createElementVNode("path", {
    d: "M8.23721 3.11897C8.14976 3.07525 8.10603 3.05338 8.06016 3.04478C8.01954 3.03716 7.97786 3.03716 7.93723 3.04478C7.89137 3.05338 7.84764 3.07525 7.76018 3.11897L1.33203 6.33305L7.76018 9.54713C7.84764 9.59085 7.89137 9.61272 7.93723 9.62132C7.97786 9.62894 8.01954 9.62894 8.06016 9.62132C8.10603 9.61272 8.14976 9.59085 8.23721 9.54713L14.6654 6.33305L8.23721 3.11897Z",
    stroke: $props.color,
    "stroke-width": "1.18222",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3)], 8, _hoisted_1);
}